import { useMemo } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { TemplateStudioModel } from 'common/contracts';
import { templateStudioStateService } from 'state/template-studio.state.service';
import { z } from 'zod';

import { RollingOffersDesignsMetadata } from 'components/TemplatesStudio/DesignsMetadata/types';

import { templateStudioSchema } from '../../../validation-schema';
import { DesignSidebarItem } from '../Components/DesignSidebarItem';

const ROLLING_OFFERS_OBJECT_PATH = 'rollingOffers';

const getRollingOffersDesignsByFilter = ({
  desktopLayout,
  themes
}: {
  desktopLayout: TemplateStudioModel['rollingOffers']['desktopLayout'];
  themes: TemplateStudioModel['rollingOffers']['themes'];
}): RollingOffersDesignsMetadata[] => {
  const relevantRollingOffersDesigns =
    templateStudioStateService.relevantRollingOffersDesigns.get() || [];

  return relevantRollingOffersDesigns.filter((currentDesign) => {
    const matchesLayout = currentDesign.layout.includes(desktopLayout);
    const matchesTheme =
      !themes || themes.length === 0 || themes.includes(currentDesign.theme);
    return matchesLayout && matchesTheme;
  });
};

export const RollingOffersDesignsSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const rollingOffersObject: TemplateStudioModel[typeof ROLLING_OFFERS_OBJECT_PATH] =
    useWatch({
      control,
      name: ROLLING_OFFERS_OBJECT_PATH
    });

  const { desktopLayout, themes } = rollingOffersObject;

  const designs = useMemo(() => {
    return getRollingOffersDesignsByFilter({ desktopLayout, themes });
  }, [desktopLayout, themes]);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="rollingOffers.selectedDesignId"
        />
      ))}
    </>
  );
};
